import { Services } from '@sigma-frontend-libs/commons'

import { components, labelModes } from '@/utils'

import selectorOwner from '@/components/selector/owner'
import selectorSendingType from '@/components/selector/sendingType'

function renderSearch(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.$search,
        label: this.getTranslate('commons.labels.search'),
        labelMode: labelModes.hidden,
        dense: true,
        details: false,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.$search = event
        }
      }
    }
  )
}
function renderType(h) {
  return h(
    selectorSendingType,
    {
      props: {
        value: this.proxy.type,
        label: this.getTranslate(`${Services.templates}.labels.type`),
        permission: `advanced.${Services.templates}.get`
      },
      on: {
        input: event => {
          this.proxy.type = event
        }
      }
    }
  )
}
function renderOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.OwnerId,
        labelMode: labelModes.hidden,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.OwnerId = event
        }
      }
    }
  )
}
export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.templates}-filter`]: true,
        [`${Services.templates}-filter--admin`]: this.canGetUsers
      }
    },
    [
      renderSearch.call(this, h),
      renderType.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}
